export const pick = <T extends Record<string, string>>({
  inputObject,
  keysToPick,
}: {
  inputObject: T;
  keysToPick: string[];
}) => {
  return Object.fromEntries(
    Object.entries(inputObject).filter(([key]) => keysToPick.includes(key)),
  );
};
